import React, { useState } from 'react';
import { BlackVisa, GreenMaster, PurpleMaster } from './CardSvg';

const Create = ({ nextStep }) => {
  const [cardType, setCardType] = useState('Visa');
  const cards = [
    {
      Component: BlackVisa,
      type: 'Visa',
    },
    {
      Component: PurpleMaster,
      type: 'MasterCard',
    },
  ];
  return (
    <div>
      <h3 style={{ color: '#CCCCCC' }}>
        Create Virtual Card • <span className="text-dark">1 of 2</span>
      </h3>
      <p
        className="mb-4"
        style={{
          maxWidth: '400px',
          fontWeight: 400,
        }}
      >
        Set Your Card Appearance, Choose From The Template Below and Make it
        More Outstanding.
      </p>
      <div
        style={{
          overflowX: 'scroll',
          width: '100%',
        }}
        className="d-flex mb-4 pt-3"
      >
        {cards.map(({ type, Component }) => (
          <div
            key={type}
            onClick={() => setCardType(type)}
            className="flex-shrink-0 mr-3"
            style={{ position: 'relative', cursor: 'pointer' }}
            data-active={cardType}
          >
            {cardType === type && (
              <span
                style={{ position: 'absolute', top: '-1rem', right: '-1rem' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <g>
                    <circle cx="24" cy="24" r="18" fill="white" />
                    <path
                      d="M46.9358 26.8006L46.0333 25.5646C45.2878 24.5444 45.278 23.1613 46.0039 22.1215L46.8868 20.8757C47.9069 19.4239 47.4361 17.413 45.8666 16.5694L44.5227 15.8435C43.4044 15.2451 42.7962 13.9993 43.0022 12.7535L43.2573 11.2429C43.5516 9.4968 42.2469 7.87825 40.4714 7.80959L38.9412 7.74092C37.6757 7.69187 36.5869 6.82865 36.2338 5.61228L35.812 4.14087C35.3215 2.43404 33.4479 1.55119 31.8097 2.25747L30.407 2.86565C29.2397 3.36593 27.8958 3.07165 27.0424 2.12014L26.0222 0.98225C24.8353 -0.342018 22.7655 -0.322399 21.5982 1.01168L20.5976 2.16919C19.7638 3.1207 18.4199 3.44441 17.2526 2.96375L15.84 2.38499C14.2019 1.70815 12.3381 2.62042 11.8672 4.33706L11.4651 5.80847C11.1413 7.04445 10.0721 7.91749 8.80671 7.98616L7.27645 8.07444C5.50095 8.17253 4.22573 9.8107 4.54944 11.547L4.8241 13.0478C5.04972 14.2936 4.46115 15.5492 3.35269 16.1574L2.01862 16.9029C0.468733 17.7661 0.0175014 19.7869 1.06711 21.219L1.96957 22.455C2.71508 23.4752 2.72489 24.8583 1.999 25.8981L1.11615 27.1439C0.0959766 28.5957 0.566827 30.6066 2.13633 31.4502L3.48022 32.1761C4.59849 32.7745 5.20667 34.0203 5.00067 35.2661L4.73582 36.7669C4.44154 38.513 5.74618 40.1315 7.52168 40.2002L9.05195 40.2689C10.3174 40.3179 11.4062 41.1811 11.7593 42.3975L12.1811 43.8689C12.6716 45.5757 14.5452 46.4586 16.1834 45.7523L17.5861 45.1441C18.7534 44.6438 20.0973 44.9381 20.9507 45.8798L21.9709 47.0177C23.1578 48.342 25.2276 48.3224 26.3949 46.9883L27.3955 45.8308C28.2293 44.8793 29.5732 44.5556 30.7405 45.0362L32.1531 45.615C33.7912 46.2918 35.655 45.3796 36.1259 43.6629L36.528 42.1915C36.8616 40.9751 37.9406 40.1021 39.206 40.0236L40.7363 39.9353C42.5118 39.8372 43.787 38.1991 43.4633 36.4628L43.1886 34.962C42.963 33.7162 43.5516 32.4606 44.66 31.8524L45.9941 31.1069C47.5342 30.2633 47.9756 28.2327 46.9358 26.8006ZM24.0015 39.5037C15.4477 39.5037 8.51243 32.5685 8.51243 24.0147C8.51243 15.4609 15.4477 8.52567 24.0015 8.52567C32.5552 8.52567 39.4905 15.4609 39.4905 24.0147C39.4905 32.5685 32.5552 39.5037 24.0015 39.5037Z"
                      fill="#67A948"
                    />
                    <path
                      d="M22.0204 24.427L20.6471 23.0439C19.833 22.2199 18.4989 22.2199 17.6749 23.0341C16.8509 23.8483 16.8509 25.1824 17.6651 26.0063L19.0384 27.3895L20.5687 28.9197C21.3632 29.7241 22.6581 29.7241 23.4624 28.9295L24.9927 27.4091L30.329 22.1022C31.153 21.288 31.153 19.954 30.3388 19.13C29.5246 18.306 28.1905 18.306 27.3666 19.1202L22.0204 24.427Z"
                      fill="#67A948"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="48" height="48" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            )}
            <Component />
          </div>
        ))}
        {/* <div className="flex-shrink-0 mr-3">
          <BlackVisa />
        </div>
        <div className="flex-shrink-0 mr-3">
          <PurpleMaster />
        </div> */}
        <div className="flex-shrink-0 mr-3 d-none">
          <GreenMaster />
        </div>
      </div>
      <a
        href="/"
        onClick={e => {
          e.preventDefault();
          nextStep();
        }}
        className="default-btn"
      >
        Continue
      </a>
    </div>
  );
};

export default Create;
